import { Component, OnInit } from '@angular/core';
import { MatLegacyDialog as MatDialog }from '@angular/material/legacy-dialog';
import { AbstractWidgetComponent, AccountInfoService, ClientContextService, ConfigurationService } from '@sdbn/appclient';
import { ContextChange } from '@sdbn/appclient';
import { ConfirmDialogComponent, ConfirmDialogData } from 'src/app/shared/confirm-dialog/confirm.dialog.component';
import { TranslationService } from '@sdbn/common';
import { VisitorUpfrontRegistationFilterModel } from '../../visitor-upfront-registration-filter/visitor-upfront-registration-filter.model';
import { DialogService } from '@sdbn/appclient';
import { PersonalVisitDetailsDialogComponent } from 'src/tmc-visit/components/personal-visit/component/personal-visit-details-dialog/personal-visit-details-dialog.component';
import { VisitReservation } from 'src/tmc-visit/components/visit-reservation/model/visit-reservation';
import { VisitReservationService } from 'src/tmc-visit/components/visit-reservation/service/visitreservation.service';
import { Visit } from 'src/tmc-visit/tmc-visit.model';
import { environment } from 'src/environments/environment';
import { HttpService } from '@sdbn/appclient';
import { PersonalVisit } from 'src/tmc-visit/widgets/personal-visit-list/personal-visit-list.model';
import { WidgetStyle } from '@sdbn/appclient';

@Component({
  selector: 'app-visitor-upfront-registration-action-bar',
  templateUrl: './visitor-upfront-registration-action-bar.component.html',
  styleUrls: ['./visitor-upfront-registration-action-bar.component.scss']
})
export class VisitorUpfrontRegistrationActionBarComponent extends AbstractWidgetComponent implements OnInit {

  filterModel = new VisitorUpfrontRegistationFilterModel();

  visitReservation: VisitReservation;

  isEditAllowed = false;
  isDeleteAllowed = false;
  isShowAllowed = false;
  resendInvitationEnabled = false;

  constructor(
    private dialog: MatDialog,
    private visitReservationService: VisitReservationService,
    public translationService: TranslationService,
    private dialogService: DialogService,
    private tmcHttpService: HttpService,
    private clientContextService: ClientContextService,
    private configurationService: ConfigurationService,
    private accountInfoService: AccountInfoService
  ) {
    super();
  }

  ngOnInit(): void {
  }

  onContextChange(contextChange: ContextChange) {
    if (contextChange.key === 'selected-visitor-upfront-registration') {
      this.visitReservation = contextChange.value;
      this.updateActionStatus();
    }
    if (contextChange.key === 'visitor-upfront-registration-selection') {
      this.filterModel = contextChange.value;
      this.updateActionStatus();
    }
  }

  onSetElementAndContext() { }

  private updateActionStatus() {
    const yard = this.clientContextService.getUnit();
    this.isEditAllowed = this.checkManageVisitReservationEnabledForUser(yard.key) && this.visitReservation != null && (
      this.visitReservation.arrival == null || this.visitReservation.arrival.length === 0)
      && (this.visitReservation.leave == null || this.visitReservation.leave.length === 0);

    this.isDeleteAllowed = this.checkManageVisitReservationEnabledForUser(yard.key) && this.isEditAllowed;
    this.isShowAllowed = this.checkManageVisitReservationEnabledForUser(yard.key) && this.visitReservation != null;
    this.resendInvitationEnabled = this.checkManageVisitReservationEnabledForUser(yard.key) && this.visitReservation != null && this.isEditAllowed;;
  }

  private checkManageVisitReservationEnabledForUser(yardKey: string): boolean {
    return this.accountInfoService.checkPrivilegeExistsForYardKey(yardKey, 'manage_visitreservation');
  }

  /**
   * Register a new visit reservation.
   */
  newVisitReservation() {
    const visitorConfirmationDefault = this.configurationService.getClientParamValue('tmc-visit.control.visitor-confirmation-default', true) === 'true';
    this.dialogService.openMaxHeight(PersonalVisitDetailsDialogComponent,
      { model: new Visit({ reservation: true, confirmed: visitorConfirmationDefault }), action: 'new-upfront' }).afterClosed().subscribe(() => this.reloadUpfrontRegistationList());
  }

  /**
   * Edit the selected visit reservation.
   */
  editVisitReservation() {
    this.tmcHttpService.postWithContext<PersonalVisit>(environment.personalVisitEndpoint + '/details', { id: this.visitReservation.id }).subscribe(result => {
      this.dialogService.openMaxHeight(PersonalVisitDetailsDialogComponent,
        { model: new Visit(result), action: 'edit-upfront' }).afterClosed().subscribe(() => this.reloadUpfrontRegistationList());
    });
  }

  /**
   * Opens the details of this visit reservation in readonly mode.
   */
  showVisitReservation() {
    this.tmcHttpService.postWithContext<PersonalVisit>(environment.personalVisitEndpoint + '/details', { id: this.visitReservation.id }).subscribe(result => {
       this.dialogService.openMaxHeight(PersonalVisitDetailsDialogComponent,
      { model: new Visit(result), readOnly: true}).afterClosed().subscribe(() => this.reloadUpfrontRegistationList());
    });
  }

  deleteVisitReservation() {
    const dialogData: ConfirmDialogData = {
      titleKey: 'tmc.visitreservation.delete.confirm-dialog.title',
      messageKey: 'tmc.visitreservation.delete.confirm-dialog.message',
      confirm: () => {
        this.visitReservationService.deleteVisitReservation({ id: this.visitReservation.id }).subscribe(result => {
          this.reloadUpfrontRegistationList();
        });
      }
    };
    this.dialog.open(ConfirmDialogComponent, {
      data: dialogData
    });
  }
  
  public resendInvitation() {
    const ident = { id: this.visitReservation.id };
    const dialogData: ConfirmDialogData = {
      titleKey: 'tmc-visit.dialog.confirm-resend.title',
      messageKey: 'tmc-visit.dialog.confirm-resend.message',
      confirm: () => {
        this.executeResendInvitation(ident)
      }
    };
    this.dialog.open(ConfirmDialogComponent, {
      data: dialogData
    });
  }

  private executeResendInvitation(ident) {
    const url = `${environment.personalVisitEndpoint}/resend-invitation`;
    this.tmcHttpService.postWithArraybufferResponse<any>(url, ident).subscribe(result => {
      return;
    }, error => {
      console.error(error);
    });
  }

  private reloadUpfrontRegistationList() {
    this.dashboardContext.setContextValue('visitor-upfront-registration-changed', new Date().getTime());
  }

  getStyle(): WidgetStyle {
    return WidgetStyle.transparent;
  }
}
